module.exports = __webpack_public_path__ + "img/album04_05.b684baac.jpg";